import { RegistryItem } from '../RegistryItem';
export class EventRegistryItem extends RegistryItem {
    constructor(init) {
        super(init);
        this.handlerName = init.handlerName;
        this.params = init.params;
        this.derivesFrom = init.derivesFrom;
    }
    handlerName;
    params;
    derivesFrom;
    get type() {
        return this.key;
    }
}
